module.exports = __webpack_public_path__ + "static/media/dots-horizontal.1dd6fa86.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Media/dots-horizontal.svg
// module id = 49
// module chunks = 0